import { ResumeLicenseSimulationResponse } from './../../models/ss-api/responses/resume.license..simulation.response';
import { ResumeLicenseSimulationRequest } from 'app/models/ss-api/requests/resume.license.simulation.request';
import { ResumeLicenseRequest } from './../../models/ss-api/requests/resume.license.request';
import { CheckHoldEligibilityResponse } from './../../models/ss-api/responses/check.hold.eligibility.response';
import { HoldRequest } from 'app/models/ss-api/requests/hold.request';
import { HoldPricingArray, HoldPricing } from './../../models/ss-api/responses/hold.pricing';
import { ssApiService } from '../../services/ss-api.service';
import { Component, OnInit } from '@angular/core';

import Swal from 'sweetalert2';
import { GlobalServices } from '../../services/global.service';
import * as moment from 'moment';
import { CancellationRequestDialogComponent } from '../cancellation-request/cancellation-request-dialog.component';
import { DashboardLicenseResponse } from 'app/models/ss-api/responses/dashboard.license.response';
import { SelectItem } from 'primeng/api';
import { CreditCardResponseArray } from 'app/models/ss-api/responses/credit.card.response';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import {DynamicDialogConfig} from 'primeng/dynamicdialog';

export interface IHoldDialogModel {
    License: DashboardLicenseResponse;
    CreditCards: SelectItem[];
    HoldResponse : CheckHoldEligibilityResponse;
}

export enum HoldRequestDialogResultTypes {
	cancelled = 0,
	success = 1,
	showCancel = 10,
	error = 99
}

@Component({
  selector: 'hold-request-dialog',
  styleUrls: ['./hold-request-dialog.component.scss'],
  templateUrl: './hold-request-dialog.component.html'
})
export class HoldRequestDialogcomponent implements IHoldDialogModel, OnInit {
    IsBusy: boolean = true;

	result = HoldRequestDialogResultTypes.cancelled;

    License: DashboardLicenseResponse;
    CreditCards: SelectItem[];
    HoldResponse : CheckHoldEligibilityResponse;
    Credit;
    State: string;
    TaxRateDisplay: string;
    isMobile: boolean;


    showHoldDuration : boolean = false;

    clickedOK : boolean = false;

    Options: HoldPricingArray;
    SelectedOption: HoldPricing;

	SelectedOptionResumeDate : Date;

    step = 1;

    showAddCreditCard: boolean;
    SelectedCreditCard;
    Initials : string = "hold";
    ShowTimeline: boolean = false;

	OriginalTitle : string = '';
	OriginalSubTitle : string = '';

    Title = 'Hold Your Membership';
    Subtitle = 'Sometimes you just need a break. Keep your GIS credits, avoid the set up fee.';

    OptionTitle = 'Select An Option';


	label_HoldOK : string = "Confirm Hold Membership";
	label_Next : string = "Hold Membership";

	today : Date = new Date();

    ResumeSimulationResponse: ResumeLicenseSimulationResponse;

    constructor(
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        private api: ssApiService,
        private gb: GlobalServices
    ) {
    }

    ngOnInit() {
        this.License = this.config.data.License;
        this.CreditCards = this.config.data.CreditCards;
        this.HoldResponse = this.config.data.HoldResponse;
        this.isMobile = this.config.data.isMobile;
        console.log(this.License);
		
		console.log("CreditCards :", this.CreditCards);

        this.GetCredit();

		console.log("HoldStartDate : ", this.License.HoldStartDate);

		console.log("Holdresponse : ", this.HoldResponse);

        this.State = this.HoldResponse.State;
        this.TaxRateDisplay = this.HoldResponse.TaxRateDisplay;

        if(this.HoldResponse.HoldPrices) {
            this.Options = this.HoldResponse.HoldPrices;

			this.SelectedOption = this.Options[0];

			this.Options.forEach( o => {
				if( o.IsSelected )
					this.SelectedOption = o;
			});
		
		}

		console.log("Options : ", this.Options);

		// UPDATE TILES
		if( this.License.IsOnHold ) {
			// LICENSE IS ON HOLD
			this.Title = 'Membership on Hold';
			this.Subtitle = 'Membership resumes on ' + moment(this.License.HoldEndDate).format('MMMM Do, YYYY');
		} else if ( this.License.IsScheduledHold ) {
			// LICENSE IS SCHEDULED FOR HOLD
			this.Title = 'Hold Starting Soon';
			this.Subtitle = 'Your hold will begin on ' + moment(this.License.HoldStartDate).format('MMMM Do, YYYY') + 
					'<br>and resume automatically on ' + moment(this.License.HoldEndDate).format('MMMM Do, YYYY');
		}

		this.OriginalTitle = this.Title;
		this.OriginalSubTitle = this.Subtitle;

        if (this.License.IsOnHold || this.License.IsScheduledHold ) {
			//UPDATE LABELS FOR EXTEND HOLD OPTIONS
			this.label_Next = "Extend Hold";
			this.label_HoldOK = "Confirm Hold Extension";            
		}
		

        if (this.CreditCards != undefined) {
            this.SelectedCreditCard = this.CreditCards[0].value;
		}
		
		this.InitializeHoldResumeDate();
		

    }

    close() {
        this.ref.close(this.result);
    }

    ToggleSelectedOption(option) {
		
		if (option.IsAvailable) {
			
			this.SelectedOption = option;	
			this.UpdateHoldResumeDate();

			this.showHoldDuration = true;

		}
		
	}
	
	InitializeHoldResumeDate() {
		if( this.License.IsOnHold ) {
			this.SelectedOptionResumeDate = this.License.HoldEndDate;
		} else {
			this.SelectedOptionResumeDate = new Date( moment(this.License.NextBillingDate).add( 1, 'months' ).toString() );
		}
	}

	UpdateHoldResumeDate() {
		
		let resumeDate : Date = this.License.IsOnHold ? this.License.HoldEndDate : this.License.NextBillingDate;

		let addMonths : number = this.SelectedOption.Months;

		if( this.License.IsOnHold ) {
			this.Options.forEach( o => {
				if( o.IsSelected )
					addMonths -= o.Months;
			});
		}
		

		this.SelectedOptionResumeDate = new Date( moment( resumeDate ).add( addMonths, 'months' ).toString() );

	}

	GetHoldDays( days : number ) : number {


		this.Options.forEach( o => {
			if( o.IsSelected )
				days -= o.Days;
		});

		return days;

	}


	HoldStartedDate( nextBillingDate : Date ) : Date {
		return new Date( moment( nextBillingDate ).add( -1, 'months' ).toString() );
	}


    ShowCancelDialog() {
		
		this.result = HoldRequestDialogResultTypes.showCancel;
		this.close();

	}
	


    GetOptions() {
        this.IsBusy = true;
        let disposable = this.api.CheckHoldEligibility(this.License.Key).subscribe(response => {
            this.IsBusy = false;
            if (response.Data.HoldEligible) {
                this.Options = response.Data.HoldPrices;
            }
            disposable.unsubscribe();
        });
    }

    GetCredit() {
        this.IsBusy = true;

        let subscription = this.api.MemberCredit().subscribe(response => {
            subscription.unsubscribe();
            this.IsBusy = false;
            this.Credit = response.Data;
        }, error => {
            subscription.unsubscribe();
            this.IsBusy = false;
        });
    }


    cardAdded({cards, newCardId}: {cards: CreditCardResponseArray, newCardId: number}) {
        this.showAddCreditCard = false;
        this.updateCreditCardOptions(cards);
        this.SelectedCreditCard = newCardId;
    }

    updateCreditCardOptions( newCards: CreditCardResponseArray ) {
        this.CreditCards = [];
        newCards.forEach(card => {
            this.CreditCards.push(
                {
                    label: 'Name: ' + card.FirstName + ' ' + card.LastName +
                        ' - Last four: ' + card.LastFour +
                        ' - exp. Date: ' + card.ExpMonth + '/' + card.ExpYear,
                    value: card.ID
                });
        });
    }

    addCardCanceled() {
        this.showAddCreditCard = false;
    }


	nextStep() {
		this.step += 1;
		this.UpdateStepTitles();
	}

    previousStep() {
		this.step -= 1;
		this.UpdateStepTitles();
    }

    goToStep(step) {
		this.step = step;
		this.UpdateStepTitles();
	}
	
	UpdateStepTitles() {
		switch (this.step) {
			case 1:
				this.Title = this.OriginalTitle;
				this.Subtitle = this.OriginalSubTitle;
				break;

			case 2:
				this.Title = this.License.IsOnHold || this.License.IsScheduledHold ? 'Extend Your Hold' : 'Hold Your Membership';
				break;

			case 5:
				this.Title = 'Resume Membership';
				this.Subtitle = 'Membership will be available immediately';
				break;

		}
	}

    CreditUsed(): number {
        let price = this.SelectedOption.PriceWithTax;

        if (this.HoldResponse.IsExtension) {
            price = this.SelectedOption.ExtensionPriceWithTax;
        }

        if (this.Credit > price) {
            return price;
        } else {
            return this.Credit;
        }
    }

    PriceDue(): number {
        let credit = this.CreditUsed();

        let price = this.SelectedOption.PriceWithTax;

        if (this.HoldResponse.IsExtension) {
            price = this.SelectedOption.ExtensionPriceWithTax;
        }

        return price - credit;
    }

    CreditCardChanged(event) {
        console.log(event);
        console.log(this.SelectedCreditCard);
    }

    IsWithinCreditPeriod() {
        return moment().isBefore(moment(this.License.HoldEndDate));
    }

    ResumeProductPrice() {
        if (this.ResumeSimulationResponse.TotalPrice === 0) {
            return 0;
        } else {
            return this.ResumeSimulationResponse.ProductPrice;
        }
    }

    OtherCreditUsed() : number {
        let otherCreditUsed : number = 0;
        let data = this.ResumeSimulationResponse;

        let otherCreditNeeded = data.Total - data.HoldCredit;

        if ( otherCreditNeeded > 0 && data.OtherCredit > 0 ) {
            if ( otherCreditNeeded > data.OtherCredit ) {
                otherCreditUsed = data.OtherCredit;
            } else {
                otherCreditUsed = otherCreditNeeded;
            }
        }

        return otherCreditUsed;
    }

    ResumeLicense() {
        this.IsBusy = true;

        if (this.step === 1) {
            let request: ResumeLicenseSimulationRequest = {
                LicenseKey: this.License.Key,
                Initials: 'aa'
            };

            let disposable = this.api.ResumeLicenseSimulation(request).subscribe(response => {
                if (response.Result && response.Data.ResumePossible) {
                    this.ResumeSimulationResponse = response.Data;
					this.step = 5;
					this.UpdateStepTitles();
                } else {
                    let message;
                    if (response.Result) {
                        message = response.Data.ResumeNotPossibleReason;
                    } else {
                        message = response.Message;
                    }
                    Swal.fire({
                        icon: 'error',
                        title: 'Cannot Resume Membership',
                        text: message
                    }).then( () => {}, () => {} );
                }
                this.IsBusy = false;
                disposable.unsubscribe();
            });
        } else if (this.step === 5) {
            let request: ResumeLicenseRequest = new ResumeLicenseRequest();

            if (this.ResumeSimulationResponse.HoldStarted == false ) {
                request.CreditCardID = this.CreditCards[0].value;
                request.LicenseKey = this.License.Key;
                request.Initials = 'resumedPendingHold';
            } else {
                request.CreditCardID = this.SelectedCreditCard;
                request.LicenseKey = this.License.Key;
                request.Initials = this.Initials;
            }

            let disposable = this.api.ResumeLicense(request).subscribe(response => {
                console.log(response);
                this.IsBusy = false;
                if (response.Result) {

					this.result = HoldRequestDialogResultTypes.success;

                    Swal.fire({
                        icon: 'success',
                        title: 'Membership Resumed',
                        text: 'Your membership is now active and available for use'
					}).then( () => { this.close() }, () => { this.close() } );
					
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Cannot Resume Membership',
                        text: response.Message
                    }).then( () => {}, () => {} );
                }
                disposable.unsubscribe();
            });
        }

       

    }

    HoldDate() {
        return moment(this.License.NextBillingDate).format('MMMM DD, YYYY');
    }

    ResumeDate() {
        if (this.HoldResponse.IsExtension) {
            return moment(this.License.HoldStartDate).add(this.SelectedOption.Months, 'months').format('MMMM DD, YYYY');
        } else {
            return moment(this.License.NextBillingDate).add(this.SelectedOption.Months, 'months').format('MMMM DD, YYYY');
        }
    }

    confirm() {
        this.clickedOK = true;
        this.IsBusy = true;
        
        // waiting on endpoint
        let request: HoldRequest = {
            CreditCardID: this.SelectedCreditCard,
            HoldItemID: this.SelectedOption.ID,
            LicenseKey: this.License.Key,
            Initials: this.Initials
        };

        if (this.HoldResponse.IsExtension) {
            let disposable = this.api.ExtendHoldLicense(request).subscribe(response => {
				disposable.unsubscribe();
				if(response.Result) {
					
					this.result = HoldRequestDialogResultTypes.success;

					Swal.fire({
                        icon: 'success',
                        title: 'Hold Extended',
                        text: 'Your Membership will resume on ' + moment(response.Data.HoldEndDate).format('MMMM Do, YYYY')
                    }).then( () => {
                        this.close();
                    }, () => {
                        this.close();
					} );
					
                } else {

					this.result = HoldRequestDialogResultTypes.error;

                    Swal.fire({
                        icon: 'error',
                        title: 'Could Not Extend Hold',
                        text: response.Message
                    }).then( () => {
                        this.close();
                    }, () => {
                        this.close();
                    } );
                }
                
                // this.IsBusy = false;
            })
        } else {
            let disposable = this.api.HoldLicense(request).subscribe(response => {
				disposable.unsubscribe();
				if (response.Result) {

					this.result = HoldRequestDialogResultTypes.success;
					
					Swal.fire({
                        icon: 'success',
                        title: 'Hold Successful',
                        text: 'Your Membership will resume on ' + moment(response.Data.HoldEndDate).format('MMMM Do, YYYY')
                    }).then( () => {
                        this.close();
                    }, () => {
                        this.close();
                    } );
				
				} else {
					
					this.result = HoldRequestDialogResultTypes.error;

                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: response.Message
                    }).then( () => {
                        this.close();
                    }, () => {
                        this.close();
					} );
					
				}
                //this.IsBusy = false;
                
            });
        }
    }

}
